import type { EquipoOffgrid, ItemOffgrid } from '../tipos'

interface Props {
  titulo: string
  /** Lo que se puede elegir. Vacia = no hay nada que agregar. */
  opciones: EquipoOffgrid[]
  filas: ItemOffgrid[]
  alCambiar: (filas: ItemOffgrid[]) => void
  /** Cuantas filas como minimo (los que no se pueden dejar vacios). */
  minimo?: number
  textoAgregar: string
}

const detalle = (e: EquipoOffgrid) =>
  e.potencia_w > 0 ? ` · ${e.potencia_w / 1000} kW` : e.capacidad_kwh > 0 ? ` · ${e.capacidad_kwh} kWh` : ''

/** Una lista de equipos con su cantidad: se elige, se pone cuantos y se agregan o quitan filas. */
export function FilasEquipo({ titulo, opciones, filas, alCambiar, minimo = 0, textoAgregar }: Props) {
  const cambiar = (i: number, parte: Partial<ItemOffgrid>) =>
    alCambiar(filas.map((f, n) => (n === i ? { ...f, ...parte } : f)))

  return (
    <fieldset className="filas-equipo">
      <legend>{titulo}</legend>
      {filas.map((f, i) => (
        <div className="fila" key={i}>
          <label>
            Equipo
            <select value={f.codigo} onChange={(e) => cambiar(i, { codigo: e.target.value })}>
              {opciones.map((o) => (
                <option key={o.codigo} value={o.codigo}>
                  {o.nombre}
                  {detalle(o)}
                </option>
              ))}
            </select>
          </label>
          <label>
            Cantidad
            <input
              type="number"
              min={1}
              max={500}
              value={f.cantidad}
              onChange={(e) => cambiar(i, { cantidad: Math.trunc(Number(e.target.value)) })}
            />
          </label>
          {filas.length > minimo && (
            <button type="button" className="enlace" onClick={() => alCambiar(filas.filter((_, n) => n !== i))}>
              Quitar
            </button>
          )}
        </div>
      ))}
      {opciones.length > 0 && textoAgregar !== '' && (
        <button type="button" className="secundario pequeno" onClick={() => alCambiar([...filas, { codigo: opciones[0]!.codigo, cantidad: 1 }])}>
          + {textoAgregar}
        </button>
      )}
    </fieldset>
  )
}
